import React, { useContext } from "react";
import ModalStepContext from "../../../../core/context/ModalStepContext";
import Input from "../../Input/InputOld";
import TextereaInput from "../../../common/Input/TextereaInput.jsx";
import SelectInput from "../../../common/Input/SelectInput.jsx";
import ModalFooter from "../ModalFooter";
import ModalCss from "../Modal.module.css";
import OrderCss from "../OrderModal/OrderModal.module.css";

const ResendTicketModal = () => {
  const { currentStep, setStep } = useContext(ModalStepContext);

  const handleEmailModalShow = () => {
    setStep(currentStep + 1);
  };
  return (
    <div className={`${ModalCss.windowHolder}`}>
      <div className={`${ModalCss.shopContainer}`}>
        <div className={`${ModalCss.modalBodyWraper}`}>
          <div className={`${ModalCss.modalBody}`}>
            <header className={`${ModalCss.modalHeader}`}>
              <h2 className={`${ModalCss.headerTitle}`}>Resend ticket</h2>
            </header>

            <div className={`${OrderCss.formHolder2}`}>
              <div className={`${OrderCss.checkoutForm} mt-4`}>
                <form action="" onSubmit={handleEmailModalShow}>
                  <dl className={`${OrderCss.zendForm}`}>
                    <SelectInput
                      id="event"
                      name="Please select the event you purchased for"
                      element="event-element"
                      required={true}
                      value={[
                        "Please select",
                        "Fri 18 March 2022 10:00 PM - 5:00 AM: Nowruz Party",
                      ]}
                    />

                    <div className={`${OrderCss.inputHolder}`}>
                      <dd
                        id="submit-element"
                        className={`${OrderCss.submitElement}`}
                      >
                        <input
                          className={`${OrderCss.submitItem}`}
                          type="submit"
                          id="submit"
                          name="submit"
                          value="Next"
                        />
                      </dd>
                    </div>
                  </dl>
                </form>
                <br className={`${OrderCss.spr}`} />
              </div>
            </div>
          </div>
        </div>

        <ModalFooter leftItems={false} />
      </div>
    </div>
  );
};

export default ResendTicketModal;
